export default __webpack_public_path__ + "static/media/betwin95_receipt.78b66d03.jpg";